import { maxLength, required, email, compare } from '@rxweb/reactive-form-validators';

export class ProductSoldModel {

    @required({ message: 'Este campo es obligatorio.' })
    @email({ message: 'Ingrese una dirección de correo válida.' })
    email: string;

    @required({ message: 'Este campo es obligatorio.' })
    name: string;

    @required({ message: 'Este campo es obligatorio.' })
    lastname: string;

    @required({ message: 'Este campo es obligatorio.' })
    phone: number;
    
    @required({ message: 'Debes aceptar los términos y condiciones.' })
    termsAccepted: boolean;
}